export const mustMatchFormat =
  (regex: string, message?: string, allowEmpty: boolean = true) =>
  (value: string) => {
    if (allowEmpty && !value) return undefined;
    return value.match(regex) ? undefined : message || 'Format invalide';
  };
